"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _common = require("../../common");
const ButtonSkeleton = exports.ButtonSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  width: _common.ICON_BUTTON_PHONE_SIZE,
  height: _common.ICON_BUTTON_PHONE_SIZE,
  [theme.breakpoints.up('sm')]: {
    width: _common.ICON_BUTTON_SIZE,
    height: _common.ICON_BUTTON_SIZE
  }
}));
